import Vue from 'vue';
import VueRouter from 'vue-router';
import { views as authViews } from '@codehq/prickles-client-auth/src';
import { views as documentsExpensesViews } from '@codehq/prickles-client-documents-expenses/src';
import { views as reportViews } from '@codehq/prickles-client-reports/src';
import { views as movieViews } from '@codehq/prickles-client-settings-movies/src';
import { views as settingsViews } from '@codehq/prickles-client-settings/src';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/settings',
    name: 'Settings',
    component: settingsViews.SettingsView,
  },
  {
    path: '/settings/uom',
    name: 'SettingsUnitOfMeasure',
    component: settingsViews.SettingsUnitOfMeasure,
  },
  {
    path: '/settings/document-statuses',
    name: 'SettingsDocumentStatuses',
    component: settingsViews.SettingsDocumentStatuses,
  },
  {
    path: '/settings/mfc-codes',
    name: 'SettingsMfcCodes',
    component: settingsViews.SettingsMfcCodes,
  },
  {
    path: '/movies',
    name: 'MovieList',
    component: movieViews.MovieList,
  },
  {
    path: '/reports/detailed',
    name: 'DetailedReport',
    component: reportViews.DetailedReport,
  },
  {
    path: '/reports/summary',
    name: 'SummaryReport',
    component: reportViews.Summary,
  },
  {
    path: '/reports/efc',
    name: 'Efc',
    component: reportViews.Efc,
  },
  {
    path: '/reports/xero-recon',
    name: 'XeroRecon',
    component: reportViews.XeroRecon,
  },
  {
    path: '/reports/xero-recon-detail',
    name: 'views-XeroReconDetail',
    component: reportViews.XeroReconDetail,
  },
  {
    path: '/reports/xero-recon-bill-payment',
    name: 'views-XeroReconBillPayment',
    component: reportViews.XeroReconBillPayment,
  },
  {
    path: '/reports/watch-list',
    name: 'WatchList',
    component: reportViews.WatchList,
  },
  {
    path: '/reports/budget-variance',
    name: 'BudgetVariance',
    component: reportViews.BudgetVariance,
  },
  {
    path: '/reports/adjustments',
    name: 'ReportAdjustments',
    component: reportViews.ReportAdjustments,
  },
  {
    path: '/reports/basic-hours',
    name: 'BasicHours',
    component: reportViews.BasicHours,
  },
  {
    path: '/reports/hours-variance',
    name: 'HoursVariance',
    component: reportViews.HoursVariance,
  },
  {
    path: '/reports/per-diem',
    name: 'PerDiem',
    component: reportViews.PerDiem,
  },
  {
    path: '/reports/missing-documents',
    name: 'MissingDocumentsReport',
    component: reportViews.MissingDocumentsReport,
  },
  {
    path: '/reports/mfc',
    name: 'Mfc',
    component: reportViews.Mfc,
  },
  {
    path: '/reports/mfc-exception',
    name: 'MfcException',
    component: reportViews.MfcException,
  },
  {
    path: '/reports/prickles',
    name: 'Prickles',
    component: reportViews.Prickles,
  },
  {
    path: '/reports/prickles2',
    name: 'Prickles2',
    component: reportViews.Prickles2,
  },
  {
    path: '/reports/prickles3',
    name: 'Prickles3',
    component: reportViews.Prickles3,
  },
  {
    path: '/reports/mfc-documents',
    name: 'MfcDocuments',
    component: reportViews.MfcDocuments,
  },
  {
    path: '/reports/recon',
    name: 'Recon',
    component: reportViews.Recon,
  },
  {
    path: '/reports/spend-per-person',
    name: 'SpendPerPerson',
    component: reportViews.SpendPerPerson,
  },
  {
    path: '/reports/rotation-number-exception',
    name: 'RotationNumberException',
    component: reportViews.RotationNumberException,
  },
  {
    path: '/documents/reports',
    name: 'CategoryDocuments',
    component: reportViews.CategoryDocuments,
  },
  {
    path: '/category-codes',
    name: 'CategoryCodeList',
    component: movieViews.CategoryCodeList,
  },
  {
    path: '/category-codes-settings',
    name: 'CategoryCodeSettings',
    component: movieViews.CategoryCodeSettings,
  },
  {
    path: '/movie',
    name: 'views-Movies',
    component: movieViews.Movies,
  },
  {
    path: '/document/expense',
    name: 'documentsExpense',
    component: documentsExpensesViews.NewDocumentExpenseView,
  },
  {
    path: '/documents',
    name: 'documents',
    component: documentsExpensesViews.Documents,
  },
  {
    path: '/expenseDocuments',
    name: 'expenseDocuments',
    component: documentsExpensesViews.ExpenseDocuments,
  },
  {
    path: '/document/timesheet',
    name: 'editDocumentTimeSheetView',
    component: documentsExpensesViews.EditDocumentTimeSheetView,
  },
  {
    path: '/documents/crew',
    name: 'editDocumentCrew',
    component: documentsExpensesViews.EditDocumentCrew,
  },
  {
    path: '/imports',
    name: 'imports',
    component: documentsExpensesViews.Imports,
  },
  {
    path: '/employees',
    name: 'employees',
    component: documentsExpensesViews.EmployeesView,
  },
  {
    path: '/xero/audits',
    name: 'xeroAudits',
    component: documentsExpensesViews.XeroAudits,
  },
  {
    path: '/documents/transactions',
    name: 'transactions',
    component: documentsExpensesViews.Transactions,
  },
  {
    path: '/employees/edit',
    name: 'employeeEdit',
    component: documentsExpensesViews.EditEmployee,
  },
  {
    path: '/reports/crew-petty-cash',
    name: 'crewPettyCash',
    component: reportViews.CrewPettyCash,
  },
  {
    path: '/reports/crew-timesheet-invoice',
    name: 'CrewTimesheetInvoice',
    component: reportViews.CrewTimesheetInvoice,
  },
  {
    path: '/crew/new',
    name: 'newCrew',
    component: documentsExpensesViews.NewCrew,
  },
  {
    path: '/login',
    name: 'Login',
    component: authViews.LoginView,
  },
  {
    path: '/register',
    name: 'Register',
    component: authViews.RegisterView,
  },
];

const router = new VueRouter({
  routes,
});
console.log(routes);
export default router;
